import { render, staticRenderFns } from "./NewIndex.vue?vue&type=template&id=0f6d6649&scoped=true&"
import script from "./NewIndex.vue?vue&type=script&lang=js&"
export * from "./NewIndex.vue?vue&type=script&lang=js&"
import style0 from "./NewIndex.vue?vue&type=style&index=0&id=0f6d6649&prod&lang=less&scoped=true&"
import style1 from "../assets/v2/css/index/index.less?vue&type=style&index=1&id=0f6d6649&prod&lang=less&scoped=true&"
import style2 from "../assets/v2/css/index/common.less?vue&type=style&index=2&id=0f6d6649&prod&lang=less&scoped=true&"
import style3 from "./NewIndex.vue?vue&type=style&index=3&id=0f6d6649&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6d6649",
  null
  
)

export default component.exports